import { TeacherDocumentKind } from '../types/teacher'

export const teacherDocumentKinds: { kind: TeacherDocumentKind; label: string }[] =
  [
    { kind: 'cv', label: 'CV' },
    { kind: 'certifications', label: 'Autocertificazioni / certificazioni extra' },
    { kind: 'identity', label: 'Documenti identità' },
  ]
